import { graphql, useStaticQuery } from 'gatsby';
import ModalPermissions from '../modal-permissions/modalPermissions';

const ModalPermissionsBussines = (props) => {
    const contentData = useStaticQuery(graphql`
        query GET_PORTAL_SERVICIOS_MODAL_NIT_NO {
            allContentfulTemplate(
                filter: {
                    titulo: { eq: "Modal portal > Parece que con este NIT no" }
                }
            ) {
                nodes {
                    imagen {
                        title
                        file {
                            url
                        }
                        gatsbyImageData(
                            formats: [AUTO, WEBP]
                            placeholder: BLURRED
                        )
                    }
                    nombre
                    subtitulo
                    descripcion {
                        raw
                    }
                    referencias {
                        ... on ContentfulTemplate {
                            copyBoton
                            redireccion
                        }
                    }
                }
            }
        }
    `);
    const content = contentData.allContentfulTemplate.nodes[0];

    return (
        <ModalPermissions
            closeModal={props.closeModal}
            content={content}
            isMobile={false}
        />
    );
};

export default ModalPermissionsBussines;
